import { useEffect } from 'react'
import { useMeSessionQuery } from '@/features/auth/hooks/use-me-session-query'
import {
  cacheWorkspaceTenantLabel,
  partialSessionFromPersistedAuth,
  resolveSessionDisplayName,
  resolveSessionRoleLabel,
  resolveSessionTenantLabel,
} from '@/features/auth/lib/session-display'
import type { MeSessionSnapshot } from '@/features/auth/api/auth-types'

export type WorkspaceSessionView = {
  snapshot: MeSessionSnapshot | undefined
  displayName: string
  roleLabel: string | null
  tenantLabel: string
  isLoading: boolean
  isError: boolean
}

/** Session query plus persisted fallbacks for header and permission gates. */
export function useWorkspaceSession(): WorkspaceSessionView {
  const query = useMeSessionQuery()
  const snapshot = query.data ?? partialSessionFromPersistedAuth()

  useEffect(() => {
    if (!query.data) return
    cacheWorkspaceTenantLabel(query.data.tenantName, query.data.tenantId)
  }, [query.data])

  return {
    snapshot,
    displayName: resolveSessionDisplayName(snapshot),
    roleLabel: resolveSessionRoleLabel(snapshot),
    tenantLabel: resolveSessionTenantLabel(snapshot),
    isLoading: query.isPending || (query.isFetching && query.data == null),
    isError: query.isError,
  }
}
